import { checkAuth } from "@/lib/auth/client/check-auth";
import { confirmRegistration } from "@/lib/auth/client/confirm-registration";
import { getCurrentToken } from "@/lib/auth/client/get-current-token";
import { sendLoginChallenge } from "@/lib/auth/client/send-login-challenge";
import { wrapper } from "@/lib/auth/client/wrapper";
import type { AuthInstance, LoginSession } from "@/lib/auth/types";

export const authClient = (client: AuthInstance) => {
  return {
    login: (email: string) =>
      wrapper(() => client.signIn(email) as Promise<LoginSession>),
    register: (username: string) =>
      wrapper(async () => {
        await client.signUp({
          username,
          password: Buffer.from(
            crypto.getRandomValues(new Uint32Array(32)), // uint32 x 32 = 1024 bits entropy, this is hugely overkill!
          ).toString("base64"),
          autoSignIn: { enabled: true },
        });
      }),
    confirmRegistration: confirmRegistration(client),
    logout: () => wrapper(() => client.signOut()),
    sendLoginChallenge: sendLoginChallenge(client),
    checkAuth: checkAuth(client),
    resendSignUpCode: (email: string) =>
      wrapper(() => client.resendSignUp(email)),
    getCurrentToken: getCurrentToken(client),
  };
};
